var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal-file-manager","ok-title":"submit","cancel-variant":"outline-secondary","scrollable":"","size":"xl","title":"File Manager"}},[_c('file-manager',{key:_vm.componentKey,attrs:{"settings":_vm.settings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }